import UserQuestionnaire from './UserQuestionnaire';

export default UserQuestionnaire;
